export const UPDATE_ORDERS = 'UPDATE_ORDERS'
export const UPDATE_PAGINATION = 'UPDATE_PAGINATION'
export const UPDATE_ORDER_STATUS = 'UPDATE_ORDER_STATUS'
export const TOGGLE_ORDER_STATUS_POPUP = 'TOGGLE_ORDER_STATUS_POPUP'
